<template>
    <div class="container block_screen">
        <div class="">
            <div class="final_page">
                <div class="container--small">
                    <i class="icon-Product-Icon_HDM_Suite main-icon f-blue"></i>
                    <p class="desc">Paragon</p>
                  <h1>Festplatten Manager™ <b>Advanced</b></h1>
                  <p>Alles für zuverlässigen Datenschutz und professionelles PC-Management!</p>
                  <ul class="hdm_list">
                    <li>Lizenz für bis zu drei PCs gültig</li>
                    <li>Verbesserte Funktionen zur Datensicherheit und Notfallwiederherstellung</li>
                    <li>Leistungsstarkes Partitionsmanagement</li>
                    <li>Umfangreiche Funktionen für die virtuelle und physische Migration</li>
                  </ul>
                </div>
                <div class="sidebar">
                    <div class="price">&euro;79,95</div>
                    <a href="https://www.paragon-software.com/in-app/HDM17/tour.html" class="btn btn_orange">JETZT KAUFEN</a>
                    <a href="" @click.prevent="changeScreen(0)">Andere Szenarien anzeigen</a>
                </div>
                <div class="screen1"></div>
                <div class="screen2"></div>
                <div class="screen3"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapMutations} from 'vuex'
    export default {
        methods: {
            ...mapMutations({
                changeScreen: 'setScreen' // map `this.add()` to `this.$store.commit('increment')`
            })
        },
    };
</script>
